// extracted by mini-css-extract-plugin
export default {"loader":"DataLoader_loader__DvqbK"};